import { useCallback } from "react";
import { useInvalidateCardEditViewsCache } from "./useInvalidateCardEditViewsCache.ts";

/** Refetches a card table and resyncs the edit drawer's cached card views. */
export const useReloadCards = (refetch: () => Promise<unknown>) => {
  const invalidateCardEditViewsCache = useInvalidateCardEditViewsCache();

  return useCallback(() => {
    invalidateCardEditViewsCache();
    void refetch();
  }, [invalidateCardEditViewsCache, refetch]);
};
